import React from 'react'
import PropTypes from 'prop-types'

import { Locked } from 'images'

import Details from './Details'
import CoachList from './CoachList'

import { Caption, Headline, Flex, ResponsiveSVG } from 'ui/acro'

const PlanHeader = ({ plan }) => {
  return (
    <Flex flexDirection='column'>
      {plan.primaryCategory && (
        <Caption variant='bold' color='grey5' mb={[null, null, '4px']}>
          {plan.primaryCategory.title}
        </Caption>
      )}
      <Headline mb={['2px', null, '3px']}>
        {plan.title}{' '}
        <ResponsiveSVG
          height={['20px', '26px']}
          width={['20px', '26px']}
          fill='primary'
          SVG={Locked}
        />
      </Headline>
      <CoachList coaches={plan.coaches} />
      <Details
        averageDuration={plan.averageClassDuration}
        difficulty={plan.difficultyLevel}
        equipment={plan.equipment}
        intensity={plan.intensityLevel}
        workoutCount={plan.workoutCount}
      />
    </Flex>
  )
}

PlanHeader.propTypes = {
  plan: PropTypes.object
}

export default PlanHeader
